export const path_query = {
  APROBADO: "oferta",
  RECHAZADO: "rechazado",
  RECHAZADO_OTROS: "rechazadoOtros",
  ERROR_TECNICO: "errorTecnico",
  INDIVIDUO_NEGATIVO: "indNegativo",
  RECHAZADO_NOSIS_CALIFICACION_ACTIVA: "rechazadoNosisCalificacionActiva"
};
